/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {DeleteEnergySchedulesRequest} from "../model/delete-energy-schedules-request";
import {DeleteRequest} from "../model/delete-request";
import {EnergySchedule} from "../model/energy-schedule";
import {ListData} from "../model/list-data";
import {SkipTriggerRequest} from "../model/skip-trigger-request";
import {SuccessResponse} from "../model/success-response";

@Injectable({
    providedIn: "root",
})
export class SimEnergyScheduleService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deleteEnergySchedule(request: DeleteRequest) {
        return super.post<boolean>(`/api/EnergySchedule/DeleteEnergySchedule`, request);
    }

    public deleteEnergySchedules(request: DeleteEnergySchedulesRequest) {
        return super.post<boolean>(`/api/EnergySchedule/DeleteEnergySchedules`, request);
    }

    public getEnergyScheduleById(id: string) {
        return super.get<EnergySchedule>(`/api/EnergySchedule/GetEnergyScheduleById`, {id: id});
    }

    public getFilteredEnergySchedules(searchTerm: string = "", searchColumn: string = "", sortColumn: string = "", sortAscending: boolean = true, page: number = 0, pageSize: number = 10000) {
        return super.get<ListData<EnergySchedule>>(`/api/EnergySchedule/GetFilteredEnergySchedules`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getStopTriggerTimeAsync(stopTriggerId: string) {
        return super.get<Date | string>(`/api/EnergySchedule/GetStopTriggerTime`, {stopTriggerId: stopTriggerId});
    }

    public skipTrigger(request: SkipTriggerRequest) {
        return super.post<boolean>(`/api/EnergySchedule/SkipTrigger`, request);
    }

    public upSertEnergySchedule(energySchedule: EnergySchedule) {
        return super.post<SuccessResponse>(`/api/EnergySchedule/UpSertEnergySchedule`, energySchedule);
    }
}